var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    clipPath: "url(#clip0_5305_22337)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.18 6.49023H9.65002C8.71237 6.54203 7.82282 6.92208 7.13721 7.56381C6.4516 8.20555 6.01363 9.06804 5.90002 10.0002H7.32002C7.42899 9.45442 7.71769 8.96084 8.14003 8.59832C8.56237 8.2358 9.09399 8.02523 9.65002 8.00023H14.18C14.8619 8.039 15.5008 8.34551 15.9578 8.85305C16.4148 9.36059 16.6528 10.0281 16.62 10.7102C16.6528 11.3934 16.4151 12.062 15.9584 12.5711C15.5017 13.0803 14.8627 13.3889 14.18 13.4302H9.65002C9.09399 13.4052 8.56237 13.1947 8.14003 12.8322C7.71769 12.4696 7.42899 11.9761 7.32002 11.4302H5.90002C6.00044 12.3733 6.43263 13.2499 7.1195 13.9038C7.80636 14.5577 8.70321 14.9463 9.65002 15.0002H14.18C15.2502 14.9383 16.2524 14.4556 16.968 13.6575C17.6836 12.8595 18.0546 11.8108 18 10.7402C18.0519 9.67138 17.6797 8.62526 16.9643 7.82938C16.249 7.0335 15.2483 6.55223 14.18 6.49023V6.49023Z",
    fill: "url(#paint0_linear_5305_22337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.35003 10H3.82003C3.47971 9.98086 3.14652 9.89474 2.83955 9.74657C2.53259 9.5984 2.25789 9.39109 2.03121 9.13654C1.80453 8.88199 1.63032 8.58519 1.51857 8.26317C1.40683 7.94116 1.35975 7.60025 1.38003 7.26C1.34721 6.57682 1.58492 5.90823 2.04164 5.39909C2.49836 4.88996 3.13731 4.5813 3.82003 4.54H8.35003C8.90606 4.56499 9.43768 4.77556 9.86002 5.13808C10.2824 5.50061 10.5711 5.99418 10.68 6.54H12.1C11.993 5.60239 11.5579 4.73282 10.8717 4.08501C10.1854 3.43721 9.29224 3.05289 8.35003 3H3.82003C2.74989 3.06197 1.74768 3.54464 1.03205 4.3427C0.316413 5.14077 -0.0545718 6.18946 2.57368e-05 7.26C-0.0518512 8.32886 0.320359 9.37498 1.03571 10.1709C1.75107 10.9667 2.75171 11.448 3.82003 11.51H8.35003C9.28769 11.4582 10.1772 11.0782 10.8628 10.4364C11.5485 9.79469 11.9864 8.93219 12.1 8H10.68C10.5711 8.54582 10.2824 9.03939 9.86002 9.40191C9.43768 9.76444 8.90606 9.975 8.35003 10V10Z",
    fill: "url(#paint1_linear_5305_22337)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.34998 10H5.34998V11.54H8.34998C9.29219 11.4871 10.1854 11.1028 10.8716 10.455C11.5578 9.80718 11.9929 8.93761 12.1 8H10.68C10.571 8.54582 10.2823 9.03939 9.85997 9.40192C9.43763 9.76444 8.90601 9.97501 8.34998 10V10Z",
    fill: "url(#paint2_linear_5305_22337)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5305_22337",
    x1: 11.95,
    y1: 15.0002,
    x2: 11.95,
    y2: 6.49023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5E9624"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#5E9724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#6CAB29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#73B82C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#76BC2D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5305_22337",
    x1: 6.05003,
    y1: 11.51,
    x2: 6.05003,
    y2: 3,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0078D4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#5EA0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5305_22337",
    x1: 10.51,
    y1: 6.82,
    x2: 7.92998,
    y2: 10.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#005BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#035DA3",
    stopOpacity: 0.97
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#0B63AA",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#196EB6",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2D7CC6",
    stopOpacity: 0.52
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#468EDB",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5EA0EF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5305_22337"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.6756a55026245b61075cdeebe2e4a6ae.svg";
export { ForwardRef as ReactComponent };